import axios from "axios";

export const TOKEN = "token";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = window.localStorage.getItem(TOKEN);
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.result === "Auth Token Has Expired"
    ) {
      window.localStorage.removeItem(TOKEN);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
